import React, {useRef, useCallback, FC, Dispatch, SetStateAction} from 'react';
import {Grid} from "@mui/material";
import SortFilter from "../SortFilter/SortFilter";
import type {PayoutsFilterParams} from "../../types/payouts";
import useAllLocationNames from "../../hooks/components/location/useAllLocationNames";
import { DateFormats } from '../constants/securspace-constants';
import moment from 'moment';
import type {SortFilterCallback} from "../SortFilter";
import {useSnackbar} from "../../context/snackbar-context";

interface IPayoutFilterProps {
  defaultFilterParams: PayoutsFilterParams;
  needsNewSummary: React.MutableRefObject<boolean>;
  setQuery: Dispatch<SetStateAction<PayoutsFilterParams>>;
}

const PayoutsFilter: FC<IPayoutFilterProps> = (props) => {
  const {defaultFilterParams, needsNewSummary, setQuery = () => {}} = props;
  const { snackbarShowMessage } = useSnackbar();

  const locations = useAllLocationNames(snackbarShowMessage);
  const initialRender = useRef(true);

  const formatDate = (date: moment.MomentInput) => {
    return date ? moment(date).format(DateFormats.DAY).toString() : '';
  }

  const getSelectFilterValue = (event: SortFilterCallback, selectFilterName: string, defaultValue: any) => {
    if (!event.selectFilters) return defaultValue;
    const selectFilter = event.selectFilters.find((selectFilters) => selectFilters.name === selectFilterName);
    return selectFilter ? selectFilter.value : defaultValue;
  }

  const handleFilterChange = useCallback((event: SortFilterCallback) => {
    if (!initialRender.current) {
      event = {
        ...event,
        startDate: event.startDate ? formatDate(event.startDate) : '',
        endDate: event.endDate ? formatDate(event.endDate) : '',
      };

      setQuery((currentQuery) => {
        const status = getSelectFilterValue(event, 'status', currentQuery.payoutCompleted);
        const payoutCompleted = getSelectFilterValue(event, 'payoutCompleted', currentQuery.payoutCompleted);

        needsNewSummary.current = (event?.location?.id && currentQuery.locationId !== event.location.id) ||
          currentQuery.status !== status ||
          currentQuery.payoutCompleted !== payoutCompleted ||
          currentQuery.startDate !== event.startDate ||
          currentQuery.endDate !== event.endDate;

        return {
          ...currentQuery,
          locationId: event.location?.id || '',
          locationName: event.location?.locationName || '',
          status,
          payoutCompleted,
          startDate: event.startDate || '',
          endDate: event.endDate || ''
        }
      })
    } else {
      initialRender.current = false;
    }
  }, [setQuery, needsNewSummary]);


  return (
    <Grid item container direction={'column'} component={'section'} mb={4}>
      <SortFilter
        filterCallback={handleFilterChange}
        locations={locations}
        defaultLocationId={defaultFilterParams.locationId}
        defaultStartDate={defaultFilterParams.startDate}
        defaultEndDate={defaultFilterParams.endDate}
      />
    </Grid>
  );
};

export default PayoutsFilter;
